// extracted by mini-css-extract-plugin
export default {"wrapper":"case-study_wrapper__pI8a2","container":"case-study_container__PA8Ke","header":"case-study_header__xDv1v","desc":"case-study_desc__RPreD"};